// @so/tg-adapter — Telegram WebApp SDK
/// <reference path="./telegram-webapp.d.ts" />
// ---- Detection ----
export function isTelegramWebApp() {
    return typeof window !== 'undefined' &&
        !!window.Telegram?.WebApp?.initData &&
        window.Telegram.WebApp.initData !== '';
}
// ---- Initialization ----
export function initTelegramWebApp() {
    const wa = window.Telegram?.WebApp;
    if (!wa)
        return;
    wa.ready();
    try {
        wa.disableVerticalSwipes();
    }
    catch { /* old SDK versions */ }
}
// ---- User data ----
export function getTGUser() {
    const user = window.Telegram?.WebApp?.initDataUnsafe?.user;
    if (!user)
        return null;
    return {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        username: user.username,
        photoUrl: user.photo_url,
        languageCode: user.language_code,
        isPremium: user.is_premium,
    };
}
export function getTGInitData() {
    const data = window.Telegram?.WebApp?.initData;
    return data && data !== '' ? data : null;
}
// ---- Start param (deep linking) ----
export function getStartParam() {
    const param = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
    return param && param !== '' ? param : null;
}
// ---- Theme ----
export function getTGColorScheme() {
    return window.Telegram?.WebApp?.colorScheme ?? 'light';
}
export function getTGThemeParams() {
    const tp = window.Telegram?.WebApp?.themeParams;
    if (!tp)
        return {};
    return {
        bgColor: tp.bg_color,
        textColor: tp.text_color,
        hintColor: tp.hint_color,
        linkColor: tp.link_color,
        buttonColor: tp.button_color,
        buttonTextColor: tp.button_text_color,
        secondaryBgColor: tp.secondary_bg_color,
        headerBgColor: tp.header_bg_color,
        accentTextColor: tp.accent_text_color,
        sectionBgColor: tp.section_bg_color,
        sectionHeaderTextColor: tp.section_header_text_color,
        subtitleTextColor: tp.subtitle_text_color,
        destructiveTextColor: tp.destructive_text_color,
    };
}
// ---- BackButton ----
export function showBackButton(callback) {
    const btn = window.Telegram?.WebApp?.BackButton;
    if (!btn)
        return;
    btn.onClick(callback);
    btn.show();
}
export function hideBackButton(callback) {
    const btn = window.Telegram?.WebApp?.BackButton;
    if (!btn)
        return;
    if (callback)
        btn.offClick(callback);
    btn.hide();
}
// ---- MainButton ----
export function showMainButton(text, callback) {
    const btn = window.Telegram?.WebApp?.MainButton;
    if (!btn)
        return;
    btn.setText(text);
    btn.onClick(callback);
    btn.show();
}
export function hideMainButton(callback) {
    const btn = window.Telegram?.WebApp?.MainButton;
    if (!btn)
        return;
    if (callback)
        btn.offClick(callback);
    btn.hide();
}
// ---- Haptic Feedback ----
export function hapticImpact(style = 'light') {
    try {
        window.Telegram?.WebApp?.HapticFeedback?.impactOccurred(style);
    }
    catch { /* noop */ }
}
export function hapticNotification(type = 'success') {
    try {
        window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred(type);
    }
    catch { /* noop */ }
}
export function hapticSelection() {
    try {
        window.Telegram?.WebApp?.HapticFeedback?.selectionChanged();
    }
    catch { /* noop */ }
}
// ---- Safe Area ----
export function getSafeAreaInset() {
    const inset = window.Telegram?.WebApp?.safeAreaInset;
    return inset ?? { top: 0, bottom: 0, left: 0, right: 0 };
}
export function getContentSafeAreaInset() {
    const inset = window.Telegram?.WebApp?.contentSafeAreaInset;
    return inset ?? { top: 0, bottom: 0, left: 0, right: 0 };
}
export function onSafeAreaChanged(callback) {
    window.Telegram?.WebApp?.onEvent('safeAreaChanged', callback);
    return () => window.Telegram?.WebApp?.offEvent('safeAreaChanged', callback);
}
export function onContentSafeAreaChanged(callback) {
    window.Telegram?.WebApp?.onEvent('contentSafeAreaChanged', callback);
    return () => window.Telegram?.WebApp?.offEvent('contentSafeAreaChanged', callback);
}
// ---- Events ----
export function onThemeChanged(callback) {
    window.Telegram?.WebApp?.onEvent('themeChanged', callback);
    return () => window.Telegram?.WebApp?.offEvent('themeChanged', callback);
}
//# sourceMappingURL=index.js.map